import * as React from "react"
import { Box, Typography } from "@mui/material"

import HelpRoas from "data/HelpRoas"
import HelpAttributionModels from "data/HelpAttributionModels"

const helpData: {
  [key: string]: {
    helpContent?: string | React.ReactNode
    loomEmbedUrl?: string | null
  }
} = {
  "/dashboard/companies/overview": {
    helpContent:
      "The companies tab gives you information on companies you are tracking, including a high level summary of each one.",
    loomEmbedUrl: null,
  },
  "/dashboard/companies/search": {
    helpContent:
      "The explore page lets you filter companies in Luz's database by various criteria.",
    loomEmbedUrl: null,
  },
  "/dashboard/companies/[id]/overview": {
    helpContent:
      "The company overview page gives you high level details about a given competitor.",
    loomEmbedUrl: "https://www.loom.com/embed/3c66770fc0a0427783de2157e0ac7f9a",
  },
  "/dashboard/companies/[id]/products": {
    helpContent:
      "The company products page has details about top products that you can filter, as well as trending products, and recent product events (like product launches).",
    loomEmbedUrl: "https://www.loom.com/embed/3c66770fc0a0427783de2157e0ac7f9a",
  },
  "/dashboard/companies/[id]/marketing": {
    helpContent:
      "The company marketing page includes events like Instagram posts, homepage changes, and emails. It also includes some high level information about traffic and ad spend.",
    loomEmbedUrl: "https://www.loom.com/embed/3c66770fc0a0427783de2157e0ac7f9a",
  },
  "/dashboard/companies/[id]/reports": {
    helpContent:
      "The exports page allows you to save a downloadable file with fine-grained daily product events about a tracked competitor.",
    loomEmbedUrl: null,
  },
  "/dashboard/companies/benchmarking/companies": {
    helpContent:
      "Company benchmarking allows you to compare your own store against another competitor you are tracking.",
    loomEmbedUrl: "https://www.loom.com/embed/5000c8da655e481c89f111f826ba69bd",
  },
  "/dashboard/companies/benchmarking/products": {
    helpContent:
      "Product benchmarking allows you to compare individual products against each other, from your own company or from competitor's.",
    loomEmbedUrl: "https://www.loom.com/embed/5000c8da655e481c89f111f826ba69bd",
  },
  "/dashboard/market-insights": {
    helpContent:
      "Market Insights lets you search by term to see how product types are performing in the market.",
    loomEmbedUrl: "https://www.loom.com/embed/f770d6ec0bd043f086c380fc21f79f57",
  },
  "/dashboard/market-insights/explore": {
    helpContent:
      "Each market insight page has details about top products, and companies selling products of the given type, as well as a look at how they've performed over time.",
    loomEmbedUrl: "https://www.loom.com/embed/f770d6ec0bd043f086c380fc21f79f57",
  },
  "/dashboard/attribution/overview": {
    helpContent: (
      <>
        <Box sx={{ mb: 1 }}>
          The customers tab has details about where orders on your store
          originate.
        </Box>
        <HelpAttributionModels />
      </>
    ),
    loomEmbedUrl: "https://www.loom.com/embed/7c099dcb7c83442f86244a1f72649cc9",
  },
  "/dashboard/attribution/paid-ads": {
    helpContent: (
      <>
        <Box sx={{ mb: 1 }}>
          The Paid Ads section helps you attribute orders to ad campaigns you
          are running, or have run.
        </Box>
        <Typography variant="h3">Important Calculations</Typography>
        <Box sx={{ fontSize: "sm" }}>
          Luz performs a number of calculations to help you understand how your
          campaigns are performing.
        </Box>
        <HelpRoas />
      </>
    ),
    loomEmbedUrl: "https://www.loom.com/embed/7c099dcb7c83442f86244a1f72649cc9",
  },
  "/dashboard/store/overview": {
    helpContent:
      "The My Store tab has analytics about your store, and a quick look at your store's general conversion funnel comparing site visitors to sales.",
    loomEmbedUrl: null,
  },
  "/dashboard/demand-planning": {
    helpContent:
      "The demand planning page lets you see insights about each variant in your inventory and ranks them.",
    loomEmbedUrl: "https://www.loom.com/embed/8eaf3af6bd534e47b509bde57a74bfe5",
  },
}

export { helpData }
